import React from 'react';
import * as PropTypes from 'prop-types';
import { Table, Button } from 'react-bootstrap';
import groupBy from 'lodash/groupBy';

import './Gradebook.sass';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faTimes,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

const categoryName = (code) => {
  switch (code) {
    case 'lesson':
      return 'Lessons';
    case 'quiz':
      return 'Quizzes';
    case 'worksheet':
      return 'Worksheets';
    case 'interactive':
      return 'Interactive Lessons';
    case 'tutorial':
      return 'Tutorials';
    case 'spec':
      return 'Specifications';
    default:
      return code.toUpperCase();
  }
};

const Gradebook = ({ exercises, grades, showResearchPage }) => {
  const categories = groupBy(exercises, 'category');

  return (
    <div className="box box-row">
      <div className="box gradebook">
        <Table size="sm" bordered>
          <thead>
            <tr>
              <th>Exercise</th>
              <th>Completed (Grade)</th>
            </tr>
          </thead>
          {Object.keys(categories).map((c) => {
            return (
              <tbody key={c}>
                <tr>
                  <th colSpan="2">{categoryName(c)}</th>
                </tr>
                {categories[c].map((ex) => {
                  const grade = grades.find((g) => g.exerciseCode === ex.code);
                  let col;
                  if (grade && grade.isComplete) {
                    col = (
                      <td className="align-middle">
                        <div className="d-flex justify-content-between">
                          <FontAwesomeIcon icon={faCheck} size="lg" />
                          <h6 className="m-0">
                            {parseInt(grade.score) >= 0 &&
                            ex.category !== 'interactive'
                              ? ` ${grade.score}`
                              : ''}
                          </h6>
                        </div>
                      </td>
                    );
                  } else {
                    col = (
                      <td>
                        <FontAwesomeIcon icon={faTimes} />
                      </td>
                    );
                  }

                  return (
                    <tr key={ex.code}>
                      <td>
                        <Button
                          size="sm"
                          variant="link"
                          onClick={() => showResearchPage(ex.code)}
                        >
                          {ex.name}
                        </Button>
                      </td>
                      {col}
                    </tr>
                  );
                })}
              </tbody>
            );
          })}
        </Table>
      </div>
    </div>
  );
};

Gradebook.defaultProps = {
  grades: [],
  exercises: [],
};
Gradebook.propTypes = {
  grades: PropTypes.array,
  exercises: PropTypes.array,
  showResearchPage: PropTypes.func,
};

export default Gradebook;
